<template>
  <v-container fluid>
    <v-row dense>
      <v-col class="text-h3 gray--text text--lighten-1">
        <PatientsCounter
          queueTitle="Provas de lentes"
          queueType="contact_lens_test"
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <authorization permissionKey="contact_lens_test_queue" can="read">
          <attendances queueType="contact_lens_test" />
        </authorization>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import attendances from "@/components/queues/attendances.vue";
  import PatientsCounter from "@/components/queues/attendance/patients_counter.vue";

  export default {
    name: "Identification",
    components: {
      attendances,
      PatientsCounter,
    },
  };
</script>

<style lang="scss" scoped></style>
